import { ListItem } from '../../../components/list';
import { Tooltip } from '../../../components/tooltip';

import { MenuLinkBookmark } from './menu-link-bookmark';
import { MenuLinkExternal } from './menu-link-external';
import { MenuLinkInternal } from './menu-link-internal';
import type { ExternalLink, InternalLink } from './menu-link-types';
import { useNavigation } from './navigation-provider';

export type RouteMenuItem = ExternalLink | InternalLink;

type RouteMenuProps = {
  item: RouteMenuItem;
  nested?: boolean;
};

const isMenuLinkExternal = (item: RouteMenuItem): item is ExternalLink =>
  'externalUrl' in item;

/** @experimental In active development. Avoid using until further notice. */
export const RouteMenu = ({ item, nested }: RouteMenuProps) => {
  const { routePrefix, isNavExpanded, handleNavLinkClick } = useNavigation();

  const sharedProps = {
    onClick: handleNavLinkClick,
    sx: {
      ...(nested && {
        pl: 9,
      }),
    },
  };

  const listItem = (
    <ListItem disablePadding>
      {isMenuLinkExternal(item) ? (
        <MenuLinkExternal
          icon={item.icon}
          title={item.title}
          externalUrl={item.externalUrl}
          {...sharedProps}
        />
      ) : item.isBookmark === true ? (
        <MenuLinkBookmark
          icon={item.icon}
          title={item.title}
          routePrefix={routePrefix}
          segment={item.segment}
          {...sharedProps}
        />
      ) : (
        <MenuLinkInternal
          icon={item.icon}
          title={item.title}
          routePrefix={routePrefix}
          segment={item.segment}
          matchSegmentOnly={item.matchSegmentOnly}
          {...sharedProps}
        />
      )}
    </ListItem>
  );

  return !isNavExpanded ? (
    <Tooltip title={item.title} placement="right">
      {listItem}
    </Tooltip>
  ) : (
    listItem
  );
};
